import {assoc, not} from 'ramda'

import {ViewReducer} from 'state/reducers/view'

export const reduceToggleMenu: ViewReducer = (state) =>
	assoc('showMenu', not(state.showMenu), state)
